import { IclienteActions } from '../../core/interfaces/customers.interface';

export class GetAllCustomersAction {
  static readonly type = '[Customers] Get All';
  constructor() {}
}

export class AddCustomerAction {
  static readonly type = '[Customers] Add New Exit Point';
  constructor(public payload: IclienteActions) {}
}

export class UpdateCustomerAction {
  static readonly type = '[Customers] Updated Exit Point';
  constructor(public payload: IclienteActions) {}
}

export class DeleteCustomerAction {
  static readonly type = '[Customers] Delete';
  constructor(public payload: string) {}
}
